module.exports = __webpack_public_path__ + "static/media/upload.0f61ed8c.svg";